/**
 * Web Feeds Transformer
 * Transforms WooRank web_feeds criteria data into React component-ready format
 */

import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates a scenario-based message for web feeds
 * @param {Array} data - The web feeds data array
 * @returns {string|null} - The appropriate message or null if data exists
 */
const generateMessage = (data = []) => {
  if (!data || data?.length === 0) {
    return 'No web feeds were found.';
  }
  return null; // No message needed when data exists (table displayed)
};

/**
 * Transforms the web_feeds criteria from WooRank API response
 * @param {Object} webFeedsCriteria - The web_feeds criteria object from the API
 * @returns {Object} - Transformed web feeds data for React components
 */
export const transformWebFeeds = (webFeedsCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!webFeedsCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No web feeds were found.',
      data: null,
    };
  }

  const data = webFeedsCriteria?.data || [];
  const wooRankStatus = webFeedsCriteria?.status || 'neutral';
  const importance = webFeedsCriteria?.importance || 0;
  const solvability = webFeedsCriteria?.solvability || 0;

  const isEmpty = !data || data?.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(data),
    data: isEmpty ? null : {
      feeds: (data || []).map((item) => ({
        href: item?.href || '',
        format: item?.format || '',
      })),
    },
  };
};

export default transformWebFeeds;

